module.exports = __webpack_public_path__ + "img/New PACI Flow - New User AR - 2.82080007.png";